import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CategoriesModel } from 'src/models/categories.model';
import { Region } from 'src/models/region';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  private regionsSubject: BehaviorSubject<Array<Region>>;
  public regions$: Observable<Array<Region>>;
  private cachedRegions: Region[] | null = null;

  constructor(private http: HttpClient) {
    this.regionsSubject = new BehaviorSubject<Array<Region>>([]);
    this.regions$ = this.regionsSubject.asObservable();
  }

  public get value(): Array<Region> {
    return this.regionsSubject.value;
  }

  update(Regions: Array<Region>){
    this.cachedRegions = Regions;
    this.regionsSubject.next(Regions);
  }
  
  list(): Observable<Array<Region>> {
    if (this.cachedRegions) {
      console.log('Returning cached regions');
      return of(this.cachedRegions);
    }
    return this.http.get(`${environment.apiUrl}region/`)
    .pipe(
      tap((data: Array<Region>) => {
        // Mise à jour du cache
        this.cachedRegions = data;
        console.log('Regions data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<Region>>;
  }
}
